<template>
	<div style="width: 100%;display: inline-block;">
		<el-row v-if="control">
			<el-col :span="6">
				<el-input v-model="day" placeholder="天" class="day" :size="$store.state.isphone?'mini':''">
					<template slot="append">天</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input v-model="hour" placeholder="时" class="hour" :size="$store.state.isphone?'mini':''">
					<template slot="append">时</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input v-model="minute" placeholder="分" class="minute" :size="$store.state.isphone?'mini':''">
					<template slot="append">分</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input v-model="second" placeholder="秒" class="second" :size="$store.state.isphone?'mini':''">
					<template slot="append">秒</template>
				</el-input>
			</el-col>
		</el-row>
		<span v-else>{{ value==0?"--":((day==0?'':(day + " 天 ")) + (hour==0?'':(hour + " 时 ")) + (minute==0?'':(minute + " 分 ")) + (second==0?'':(second + " 秒 "))) }}</span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			
		},
		props: {
			value: {
				type: Number,
				default: 0
			},
			control: {
				type: Boolean,
				default: true
			}
		},
		mounted: function () {
			
		},
		computed:{
			day: {
				get () {
					return parseInt(Number(this.value)/60/60/24);
				},
				set (value) {
					let days=Number(value);
					if(!days)
					{
						days=0;
					}
					if(days>9999)
					{
						days=9999;
					}
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', days*60*60*24+this.hour*60*60+this.minute*60+this.second);
					}
					o.input();
				}
			},
			hour: {
				get () {
					return parseInt(Number(this.value)/60/60)%24;
				},
				set (value) {
					let hours=Number(value);
					if(!hours)
					{
						hours=0;
					}
					if(hours>23)
					{
						hours=23
					}
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.day*60*60*24+hours*60*60+this.minute*60+this.second);
					}
					o.input();
				}
			},
			minute: {
				get () {
					return parseInt(Number(this.value)/60)%60;
				},
				set (value) {
					let minutes=Number(value);
					if(!minutes)
					{
						minutes=0;
					}
					if(minutes>59)
					{
						minutes=59
					}
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.day*60*60*24+this.hour*60*60+minutes*60+this.second);
					}
					o.input();
				}
			},
			second: {
				get () {
					return Number(this.value)%60;
				},
				set (value) {
					let seconds=Number(value);
					if(!seconds)
					{
						seconds=0;
					}
					if(seconds>59)
					{
						seconds=59
					}
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.day*60*60*24+this.hour*60*60+this.minute*60+seconds);
					}
					o.input();
				}
			}
		}
	}
</script>

<style scoped>
	.day,.hour,.minute,.second{
		width: 100%;
		padding-right: 20px;
	}
</style>

<style>
	@media screen and (min-width: 0px) and (max-width: 700px){
		.el-input-group__append{
			padding: 0 5px;
		}
	}
</style>
